// Account filter configuration for different sites
// Maps site IDs to allowed account IDs for various contexts

export interface SiteAccountConfig {
  paymentAccounts: number[]; // Account IDs allowed for payment receipts
  expenseAccounts: number[]; // Account IDs allowed for expense payments
}

export interface AccountFilterConfig {
  sites: Record<number, SiteAccountConfig>;
  defaultAccounts: SiteAccountConfig;
}

// Account ID reference (from database):
// 1 = Cash - Mogappair
// 2 = Main Bank Account
// 204 = Cash - Medavakkam
// Add more account IDs as needed

export const accountFilterConfig: AccountFilterConfig = {
  sites: {
    // Site 1: Mogappair
    1: {
      paymentAccounts: [1, 2], // Cash (Mogappair), Main Bank
      expenseAccounts: [1, 2], // Cash (Mogappair), Main Bank
    },
    // Site 4: Medavakkam
    4: {
      paymentAccounts: [204, 2], // Cash (Medavakkam), Main Bank
      expenseAccounts: [204, 2], // Cash (Medavakkam), Main Bank
    },
    // Add more sites as needed
  },
  // Default accounts when site is not configured or not selected
  defaultAccounts: {
    paymentAccounts: [1, 2, 204], // All cash and bank accounts
    expenseAccounts: [1, 2, 204], // All cash and bank accounts
  },
};

// Helper function to get account IDs for a specific site and context
export function getAccountIdsForSite(
  siteId: number | null | undefined,
  context: 'payment' | 'expense'
): number[] {
  if (!siteId) {
    return context === 'payment' 
      ? accountFilterConfig.defaultAccounts.paymentAccounts
      : accountFilterConfig.defaultAccounts.expenseAccounts;
  }

  const siteConfig = accountFilterConfig.sites[siteId];
  if (!siteConfig) {
    return context === 'payment'
      ? accountFilterConfig.defaultAccounts.paymentAccounts
      : accountFilterConfig.defaultAccounts.expenseAccounts;
  }

  return context === 'payment' 
    ? siteConfig.paymentAccounts
    : siteConfig.expenseAccounts;
}